import { parseHlsManifests } from './hls-manifest-parser';
function getSubManifestUrls(manifest) {
    const urls = [];
    const lines = manifest.split('\n');
    for (let i = 0; i < lines.length; i++) {
        const line = lines[i].trim();
        if (line.startsWith('#EXT-X-STREAM-INF:')) {
            // The next line should contain the URI
            if (i + 1 < lines.length) {
                const uriLine = lines[i + 1].trim();
                if (!uriLine.startsWith('#')) {
                    urls.push(uriLine);
                }
            }
        }
        if (line.startsWith('#EXT-X-MEDIA:') && line.includes('TYPE=AUDIO')) {
            // Extract audio stream URI
            const uriMatch = line.match(/URI="([^"]+)"/);
            if (uriMatch) {
                urls.push(uriMatch[1]);
            }
        }
    }
    return urls;
}
export async function getHlsManifest(httpClient, manifestUrl) {
    const baseUrl = manifestUrl.split('/').slice(0, -1).join('/');
    const mainManifest = await httpClient.fetchText_m(manifestUrl);
    const subManifestUrls = getSubManifestUrls(mainManifest);
    const subManifests = {};
    await Promise.all(subManifestUrls.map(async (url) => {
        const fullUrl = `${baseUrl}/${url}`;
        const content = await httpClient.fetchText_m(fullUrl);
        subManifests[url] = content;
    }));
    return parseHlsManifests(mainManifest, subManifests);
}
